/**
 * Format seconds to M:SS format
 * @param seconds number of seconds
 * @returns string formatted as M:SS
 */
export const formatTime = (seconds: number): string => {
  if (isNaN(seconds)) return "0:00";
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
};
